var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 8,
    viewBox: "0 0 267 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.512 4.35358C266.707 4.15832 266.707 3.84173 266.512 3.64647L263.33 0.464491C263.135 0.269228 262.818 0.269228 262.623 0.464491C262.427 0.659753 262.427 0.976335 262.623 1.1716L265.451 4.00002L262.623 6.82845C262.427 7.02371 262.427 7.3403 262.623 7.53556C262.818 7.73082 263.135 7.73082 263.33 7.53556L266.512 4.35358ZM0.158203 4.5L266.158 4.50002L266.158 3.50002L0.158203 3.5L0.158203 4.5Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightLarge);
export default __webpack_public_path__ + "static/media/ArrowRightLarge.d21b552120830f58266cb97727a42899.svg";
export { ForwardRef as ReactComponent };